import {
  validateEmail,
  validateUSPhoneNumber,
} from '@linqpal/models/src/helpers/validations'
import { TFunction } from 'i18next'
import { IPasswordError } from '../components/CreatePassword/types'

export const validateRequiredField = (value: string, t: TFunction): string => {
  return value ? '' : t('integrations.pay-as-guest.contact-section.empty-field')
}

export const validateEmailField = (value: string, t: TFunction): string => {
  if (!value) {
    return t('integrations.pay-as-guest.contact-section.empty-field')
  }
  if (!validateEmail(value)) {
    return t('integrations.pay-as-guest.contact-section.email-invalid')
  }
  return ''
}

export const validatePhoneNumberField = (
  value: string,
  t: TFunction,
): string => {
  const numericValue = value.replace(/\D/g, '').slice(0, 10)
  if (!numericValue) {
    return t('integrations.pay-as-guest.contact-section.empty-field')
  }

  if (numericValue.length < 10) {
    return t('integrations.pay-as-guest.contact-section.phone-invalid-length')
  }

  if (!validateUSPhoneNumber(numericValue)) {
    return t('integrations.pay-as-guest.contact-section.phone-invalid')
  }
  return ''
}

export const validatePassword = (value: string): IPasswordError | null => {
  const res: IPasswordError = {
    length: value.length >= 8,
    uppercase: /[A-Z]/.test(value),
    number: /\d/.test(value),
  }

  const allValid = Object.values(res).every((isValid) => isValid)

  return allValid ? null : res
}
